<template>
  <div id="pc-login">
    <div class="pc-login-layout">
      <div class="pc-LoginTitle">
        <div class="pc-title-position">
          <div class="Title-1">智慧笔记</div>
          <div class="Title-2">欢迎来到智慧笔记，您的远程在线课堂。</div>
        </div>
        <div class="pc-dangerTitle">
          <span class="dangerTitle-1">登录即表示你已阅读并同意</span>
          <span class="dangerTitle-2" @click="agreement">《用户协议》</span>
          <!-- <span class="dangerTitle-2">《隐私协议》</span> -->
        </div>
      </div>
      <div class="pc-login-group">
        <div style="font-size: 36px;font-weight: bolder">
          欢迎回来
        </div>
        <div class="pc-bottom-solid">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div>
          <div style="font-size: 16px;text-align: left;">账号：</div>
          <el-input v-model="username" placeholder="账户名/手机号码" class="name" size="medium"/>
        </div>
        <div>
          <div  style="font-size: 16px;text-align: left;">密码：</div>
          <el-input v-model="password" placeholder="请输入密码" show-password class="pass" size="medium"/>
        </div>
        <div class="btn-box">
          <el-button
              type="primary"
              class="login-btn"
              small
              @click="logins"
          >登录</el-button>
        </div>
      </div>
    </div>

<!--    <van-cell-group>-->
<!--      <van-field-->
<!--        type="tel"-->
<!--        v-model="username"-->
<!--        class="Phone"-->
<!--        name="username"-->
<!--        clearable-->
<!--        placeholder="请输入手机号码"-->
<!--        style="margin-bottom:10vw"-->
<!--      />-->
<!--      <van-field-->
<!--        v-model="password"-->
<!--        :type="pwdType"-->
<!--        class="PassWord"-->
<!--        :right-icon="quest"-->
<!--        placeholder="请输入密码"-->
<!--        style="margin-bottom:8vw"-->
<!--        @click-right-icon="change()"-->
<!--      />-->
<!--    </van-cell-group>-->
<!--    &lt;!&ndash; <div class="checked">-->
<!--      <van-checkbox v-model="checked" checked-color="#07c160" @click="pwdcheck"></van-checkbox>-->
<!--      <span>是否记住密码</span>-->
<!--    </div> &ndash;&gt;-->

<!--    <van-button-->
<!--      class="logins"-->
<!--      :class="password!=''&&username!=''?'btnColor':''"-->
<!--      @click="logins()"-->
<!--    >登录</van-button>-->

  </div>
</template>

<script>
import { button, Field, Icon, Cell, Toast, CellGroup, Popup } from "vant";
import { login } from "@/api/login.js";
import { jpush } from "@/utils/jpush";
export default {
	name:'index',
  components: {
    [button.name]: button,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
  },
  data() {
    return {
      quest: "closed-eye",
      checked: false,
      username: "",
      password: "",
      pwdType: "password",
    };
  },
  mounted() {
		if(this.isMOBILE()){
			this.$router.push({
        path:'/login'
      })
    }
    if (localStorage.getItem("userName")&&localStorage.getItem("userName") != "") {
      this.username = localStorage.getItem("userName");
    }
    if (localStorage.getItem("password")&&localStorage.getItem("password") != "") {
      this.password = localStorage.getItem("password");
      this.checked = true;
    }
  },
  methods: {
    change() {
      this.quest = this.quest === "closed-eye" ? "eye-o" : "closed-eye";
      this.pwdType = this.pwdType === "password" ? "text" : "password";
    },
    logins() {
      if (this.username === "") {
        this.$notify({
	        message: "用户名不能为空",
	        type: "info",
	        duration: 2000,
        });
        return false;
      }
      if (this.password === "") {
        this.$notify({
	        message: "密码不能为空",
	        type: "info",
	        duration: 2000,
        });
        return false;
      }
      localStorage.setItem("userName", this.username);
      if (this.checked) {
        localStorage.setItem("password", this.password);
      } else {
        localStorage.removeItem("password");
      }
      login({
        username: this.username,
        password: this.password,
      }).then((res) => {
        if (res.code === 0) {
          const data = JSON.stringify(res.user.user);
          localStorage.setItem("user", data);
          // 单独存储token
          localStorage.setItem("Token", res.user.user.token);
          // this.jpushHandel();
          this.$router.push({name:'PChome'});
        } else {
	        this.$notify({
		        message: res.msg,
		        type: "error",
		        duration: 2000,
	        });
        }
      });
    },
    // 设备号绑定
    async jpushHandel() {
      await jpush();
    },
    agreement() {
      this.$router.push("userAfreement");
    },
    pwdcheck() {
      console.log(this.checked);
    },
	  isMOBILE () {
		  let flag = navigator.userAgent.match(
			  /(phone|pad|pod|iphone|ipod|ios|iPad|Android|Mobild|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|webOS|Symbian|Windows Phone)/i
		  )
		  return flag
	  }
  },
};
</script>
<style lang="less" scoped>
#pdfs {
  width: 220vw;
}
#pc-login {
  background: #fff  url("~@/assect/bgimg.jpg") no-repeat center;
  background-size: 100% 100%;
  height: 100vh;
  .pc-LoginTitle {
    position: relative;
    /*margin: 31vw 0 20vw 0;*/
    /*padding-left: 8.9vw;*/

    font-family: SourceHanSansCN-Bold;
    font-weight: 600;
    .pc-title-position{
      margin: 37% 25%;

    }
    .Title-1 {
      color: #fff;
      font-size: 46px;
    }
    .Title-2 {
      color: #fff;
      font-size: 14px;
    }
  }
  .pc-login-layout{
    display: flex;
    justify-content: space-between;
    height: 100%;
    & > div{
      width: 50%;
    }
    .pc-login-group{
      width: 40%;
      padding: 180px 40px 0;
      background: #fff;
    }
  }
  .pc-login-group{
    width: 50%;
    float: right;
    text-align: center;
    .pc-bottom-solid{
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      span{
        width: 30%;
        border-bottom: 1px solid #b9b9b8;
      }
    }
    & > div{
      margin: 50px auto;
      width: 340px;
    }
    span{
      font-size: 18px;
    }
    .name,.pass{
      .el-input--medium .el-input__inner{
        border-radius: 10px;
        border-bottom: 1px solid #b8b7b7;
      }
    }
    .btn-box{

    }
    .login-btn{
      width: 100%;
      border-radius: 20px;
      height: 46px;
      /*float: right;*/
    }
  }
}
.pc-dangerTitle {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  .dangerTitle-1 {
    color: #d3d8dc;
  }
  .dangerTitle-2 {
    color: #25c991;
  }
}
.checked {
  // background-color: pink;
  display: flex;
  span {
    margin-left: 3vw;
    font-size: 4vw;
    color: #999;
  }
}
</style>
